import {atomWithReset} from 'jotai/utils'

export const singlePlayerResultState = atomWithReset(0)
